import { Col, ColType, Crud, CrudApi,CrudOption } from "../../comp/crud";
import {
  ApiClient,
  ApiDocInfo,
  displayTrafficAppStatus,
  getTrafficAppStatusOpt,
  Menu,
} from "../../api/ApiClient";

import {
  Button,
  Checkbox,
  Form,
  Modal,
  Toast,
  Typography,
  Descriptions,
  InputNumber,
} from "@douyinfe/semi-ui";
import { useState, useEffect } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { IconBookOpenStroked } from "@douyinfe/semi-icons";
import ContactsSideSheet from "../../comp/ContactsSideSheet";

const apiClient = ApiClient.getDefault();
export default function TeamMember() {
  const [crudApi, setCrudApi] = useState<CrudApi>();
  const [showContacts, setShowContacts] = useState(false);
  const [statData, setStatData] = useState([{ key: "", value: "统计" }]);
  const [statDataObj, setStatDataObj] = useState([] as any);
  const [statLoading, setStatLoading] = useState(false);

  const getAvailableOpts = async (): Promise<CrudOption[]> => {
    const sourceVisible: any = [
      {
        label: "接单",
        value: 1,
        key: 1,
      },
      {
        label: "未接单",
        value: 0,
        key: 0,
      },
    ];
    return sourceVisible;
  };

  useEffect(() => {
    //刷新统计
    initUserStatCountData();
  }, [statDataObj]);

  useEffect(() => {
  }, []);

  const handleCheckboxClick = async (id: any, available: any) => {
    await apiClient.request("/teamMember/availability", "PUT", undefined, {
      id: id,
      available: available,
    });
    Toast.info("已更新");
    crudApi?.refresh();
  };
  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      type: ColType.NUMBER,
    },
    {
      name: "销售",
      key: "name",
      type: ColType.STRING,
      showInFilter: true,
    },
    {
      name: "城市",
      key: "city",
      type: ColType.SELECT,
      showInFilter: true,
      getOptions: (row) => apiClient.getDictAsOpts("city"),
    },
    {
      name: "角色",
      key: "role",
      type: ColType.SELECT,
      hideInList: true,
      showInFilter: true,
      getOptions: async () => {
          return [{
            label: '管理员',
            value: 'root',
            key: 'root',
          },{
            label: '监控员',
            value: 'monitor',
            key: 'monitor',
          },{
            label: '负责人',
            value: 'quzhang',
            key: 'quzhang',
          },{
            label: '主管',
            value: 'sale_manager',
            key: 'sale_manager',
          },{
            label: '顾问',
            value: 'sale',
            key: 'sale',
          },{
            label: '学徒',
            value: 'student',
            key: 'student',
          }, {
            label: '前台',
            value: 'foreground',
            key: 'foreground',
          }, {
            label: '按揭主管',
            value: 'agent_manager',
            key: 'agent_manager',
          }, {
            label: '按揭专员',
            value: 'agent',
            key: 'agent',
          }, {
            label: '外部还款人',
            value: 'paymentUser',
            key: 'paymentUser',
          }];
  
      },
      render: (value) => {
        return value.join(", ");
      },
    },
    {
      name: "角色",
      key: "roleName",
      type: ColType.SELECT,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "手机",
      key: "mobile",
      type: ColType.STRING,
      showInFilter: true,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
    {
      name: "团队",
      key: "teamName",
      type: ColType.STRING,
      showInFilter: false,
    },
    {
      name: "上级",
      key: "managerName",
      type: ColType.STRING,
    },
    {
      name: "客户分值上限",
      key: "leadsScoreCap",
      optional: true,
      hideInList: true,
      type: ColType.NUMBER,
    },
    {
      name: "今日新客户数",
      optional: true,
      key: "todayLeads",
      type: ColType.NUMBER,
    },
    {
      name: "每日新客户数上限",
      optional: true,
      key: "leadsDailyCap",
      width: 130,
      type: ColType.NUMBER,
      render: (a, b) => (
        <InputNumber
          style={{ width: "100px" }}
          formatter={(value) => `${value}`.replace(/\D/g, "")}
          value={b.leadsDailyCap}
          onBlur={(e) => handleLeadsDailyCapBlur(b, e.target.value)}
        />
      ),
    },
    {
      name: "本月新客户数",
      optional: true,
      key: "newLeadMonthCount",
      type: ColType.NUMBER,
    },
    {
      name: "总新客户数",
      optional: true,
      key: "newLeadAllCount",
      type: ColType.NUMBER,
    },
    // {
    //   name: "总客户数上限",
    //   optional: true,
    //   key: "leadsTotalCap",
    //   type: ColType.NUMBER,
    // },
    {
      name: "接单状态",
      key: "available",
      type: ColType.SELECT,
      showInFilter: true,
      hideInList:true,
      getOptions: () => getAvailableOpts(),
    },
    {
      name: "接单状态",
      key: "available",
      type: ColType.STRING,
      showInFilter: false,
      render: (a, b) => (
        <Checkbox
          defaultChecked={a}
          onChange={() => handleCheckboxClick(b.id, !b.available)}
        />
      ),
    },
  ];

  const initUserStatCountData = async () => {
    if (statDataObj.length == 0) {
      return;
    }
  
    const data = [
      { key: "", value: "统计" },
      { key: "正常用户", value: statDataObj.total },
      { key: "接单中", value: statDataObj.available },
      { key: "今日新客户数", value: statDataObj.todayLeads },
      {
        key: "每日新客户数上限",
        value: statDataObj.leadsDailyCap,
      },
    ];
    setStatData(data);
  };

  const queryUserStatCount = async (data: any) => {
    setStatLoading(true);
    let params = {
      ...data,
    };
    console.log("统计报表查询参数：", params);
    
      apiClient.getTeamUserStat(params).then((resp) => {
        setStatLoading(false);
        setStatDataObj(resp.data);
      });
    

  };

  const userStat = () => {
    const style = {
      boxShadow: "var(--semi-shadow-elevated)",
      backgroundColor: "var(--semi-color-bg-2)",
      borderRadius: "4px",
      padding: "10px",
      margin: "auto",
    };
    return (
      <div style={{ display: "flex", width: "100%", margin: "5px" }}>
        <Descriptions data={statData} row style={style} />
      </div>
    );
  };

  const handleLeadsDailyCapBlur = async (user: any, leadsDailyCap: any) => {
    user.leadsDailyCap = leadsDailyCap;
    await apiClient
      .request("/users/updateDailyCap", "PUT", undefined, {
        id: user.id,
        leadsDailyCap: leadsDailyCap,
      })
      .then((res) => {
        if (res.code == "ok") {
          crudApi?.refresh();
          Toast.info("已更新");
        } else {
          Toast.info("更新失败");
        }
      });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", margin: "0 16px 8px" }}>
        <Button icon={<IconBookOpenStroked />} onClick={() => setShowContacts(true)}>查看通讯录</Button>
      </div>
      <ContactsSideSheet visible={showContacts} onClose={() => setShowContacts(false)} />
      {userStat()}

      <Crud
        getCrudApi={(api) => setCrudApi(api)}
        fetchDataAfterMethod={queryUserStatCount}
        canExport={true}
        name="团队成员"
        entityKey="teamMember"
        pageSize={50}
        cols={cols}
        rowActionWidth={40}
      />
    </>
  );
}
